// extracted by mini-css-extract-plugin
export default {"button_body":"Button_button_body__dBmlS","text_icon_container":"Button_text_icon_container__o9niM"};